var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"base-autocomplete-product"}},[_c('v-autocomplete',_vm._b({attrs:{"items":_vm.products,"value":_vm.productNameByValue,"clearable":"","item-text":"productname","item-value":"productname","label":"Product"},on:{"input":_vm.findId}},'v-autocomplete',_vm.$attrs,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-026e8371","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseAutocompleteProduct.vue
// module id = null
// module chunks = 